import { useQueryClient } from '@tanstack/react-query'

export const useGetFetchQuery = <T,>(key: unknown[]): T | undefined => {
  const queryClient = useQueryClient()

  return queryClient.getQueryData<T>(key)
}
